import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// action creators
import { doneIndicator } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import { TAG_FETCH_REQUEST, TAG_FETCH } from 'store/constants/tagTypes';

// schemas
import { tagSchema } from 'store/schemas/tagSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';

const WATCH_TYPE = TAG_FETCH_REQUEST;
const TYPE = TAG_FETCH;

export function* fetchTagsSaga(action: any) {
  const {
    payload: { groupId },
  } = action;

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(client.get, '/tags', {
      params: { group_id: groupId, type: 'label' },
    }),
    {
      schema: [tagSchema],
    }
  );

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, fetchTagsSaga);
}

export default function* root() {
  yield all([fork(watch)]);
}
